import requester from "../requester";
import { GET_CATEGORY } from "../../constants";

const Category = {
    getCategory: () => requester.get(GET_CATEGORY),
};

export default Category;
